import type { PageHandle } from 'app/types';

const handle: PageHandle = {
  head: {
    title: 'Page Not Found',
  },
};

export default handle;
